/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutOrderController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'Order';
            $scope.registerControl(controlName, $element.get(0));

            var deliveryAvailabilities, orderDeliveryAvailability, pickupAvailabilities, orderPickupAvailability;
            var firstLoadForProducts = true, firstLoadForStore = true;

            $scope.Config.IsShippingEnabled = $element.data('shipping');
            $scope.Config.IsStorePickupEnabled = $element.data('storepickup');
            $scope.Config.IsGiftWrapEnabled = $element.data('giftwrap');
            $scope.Config.IsCouponEnabled = $element.data('coupon');
            $scope.Config.IsGiftCardEnabled = $element.data('giftcard');
            $scope.Config.CheckCrossTabsConcurrency = $element.data('tabs-cross-check') === true;
            $scope.Config.IsLoyaltyCouponEnabled = $element.data('loyaltycoupon');
            $scope.Config.IsTimeslotEnabled = $element.data('timeslot');
            $scope.Config.ShowShippingMethodForStoreDelivery = $element.data('show-shipping-method-for-store');
            $scope.Config.RequestBillingAddressOnPickingFromStore = $element.data('request-billing-address-on-picking-from-store');
            $scope.Config.IsExplicitTimeslotEnabled = $element.data('explicittimeslot');
            $scope.Config.IsLazyloadAvailabilitiesEnabled = $element.data('lazyload-availabilities');

            $element.get(0).reload = function () {
                var deferred = $q.defer();
                ControlService.getCheckoutData("GetOrderData", $scope, $element).then(function (response) {                  
                    $scope.Model = {};
                    angular.extend($scope.Model, response);
                    //extend b2b model
                    $scope.Control.extendB2BModel();
                    //extend model
                    if (checkoutOverrides && checkoutOverrides.Order && typeof checkoutOverrides.Order.ExtendModel === 'function'){
                        $.extend($scope.Model.Data,checkoutOverrides.Order.ExtendModel($scope.Model.Data));
                    }

                    $scope.Model.Data.CanCreateAccount = checkoutConfig.canCreateAccount;
                    $scope.setControlValue(controlName, $scope.Model.Data);
                    $scope[controlName].Texts = $scope.Model.Text;
                    
                    if (response.Data.Products.length === 0)
                    {
                        $scope.Locked = true;
                        document.location = LhApp.Url.Page.Cart;
                    }

                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            $element.get(0).submit = function (testCode) {
                var deferred = $q.defer();
                
                var profile = CommonUtils.clone($scope.Order.Current.Profile);
                var deliveryPoint = $scope.Order.Current.DeliveryPoint;
                var store = $scope.Order.Current.Store;
                var shippingAddress = CommonUtils.clone($scope.Order.Current.Shipping);
                var comments = $scope.Order.Current.Comments || '';
                var billingAddress = CommonUtils.clone($scope.Order.Current.Billing);

                var prScope = angular.element('.x-control.x-angular-control.x-checkoutprofile').scope();
                var sellerCode = prScope.Control.Form.SellerCode || '';

                if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.UpdateOnSubmit === 'function') {
                    shippingAddress = checkoutOverrides.Shipping.UpdateOnSubmit(shippingAddress, profile);
                }

                if ($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && $scope.Order.Current.DeliveryPoint.Code.indexOf("onSite") > -1 ) {
                    billingAddress = CommonUtils.clone(shippingAddress);
                    if ($scope.Order.Current.Billing.IsInvoice) {
                        billingAddress.IsInvoice = true;
                        billingAddress.CompanyName = $scope.Order.Current.Billing.CompanyName;
                        billingAddress.Occupation = $scope.Order.Current.Billing.Occupation;
                        billingAddress.Headquarters = $scope.Order.Current.Billing.Headquarters;
                        billingAddress.TaxAgency = $scope.Order.Current.Billing.TaxAgency;
                        billingAddress.TaxIdentifier = $scope.Order.Current.Billing.TaxIdentifier;
                        billingAddress.PurchaseOrderNumber = $scope.Order.Current.Billing.PurchaseOrderNumber;
                        billingAddress.TaxAgencyId = $scope.Order.Current.Billing.TaxAgencyId;
                        billingAddress.VatStatus = $scope.Order.Current.Billing.VatStatus;
                        billingAddress.VatStatus = parseInt(billingAddress.VatStatus);
                        billingAddress.ExcludeVat = $scope.Order.Current.Billing.ExcludeVat;
                        billingAddress.ExcludeVatJson = $scope.Order.Current.Billing.ExcludeVatJson;
                        billingAddress.NomralVat = $scope.Order.Current.Billing.NomralVat;
                    }
                    if ($scope.Order.Current.Billing.EInvoiceModuleEnabled) {
                        billingAddress.EInvoiceModuleEnabled = $scope.Order.Current.Billing.EInvoiceModuleEnabled;
                        billingAddress.ReceiveEinvoice = $scope.Order.Current.Billing.ReceiveEinvoice;
                    }
                }
                var shippingMethod = CommonUtils.clone($scope.Order.Current.ShippingMethod);
                var paymentMethod = CommonUtils.clone($scope.Order.Current.PaymentMethod);
                var orderType = CommonUtils.clone($scope.Order.Current.OrderType);
                var orderTimeslot = CommonUtils.clone($scope.Order.Current.OrderTimeslot);
                var orderExplicitTimeslot = CommonUtils.clone($scope.Order.Current.OrderExplicitTimeslot);
                var coupon = $scope.Order.Current.Coupon;
                var giftWrap = CommonUtils.clone($scope.Order.Current.GiftWrap);
                var password = $scope.Password ? ($scope.Password.Current.Password || '') : '';
                var pickupPoint = $scope.PickupPoint && $scope.PickupPoint.Current && CommonUtils.clone($scope.PickupPoint.Current);
                
                if (checkoutOverrides && checkoutOverrides.Profile && typeof checkoutOverrides.Profile.UpdateOnSubmit === 'function'){
                    profile = checkoutOverrides.Profile.UpdateOnSubmit(orderType,billingAddress,shippingAddress,profile);
                }
                if ($scope.Config.CheckCrossTabsConcurrency) {
                    var products = $scope.Order.Current.Products;
                	ControlService.getCheckoutData("GetOrderData", $scope, $element).then(function (response) {
                		$scope.Model = {};
                		angular.extend($scope.Model, response);
                		if (checkoutOverrides && checkoutOverrides.Order && typeof checkoutOverrides.Order.ExtendModel === 'function'){
                            $.extend($scope.Model.Data,checkoutOverrides.Order.ExtendModel($scope.Model.Data));
                        }
                        $scope.Model.Data.CanCreateAccount = checkoutConfig.canCreateAccount;
                        $scope.setControlValue(controlName, $scope.Model.Data);
                        $scope[controlName].Texts = $scope.Model.Text;
                		$scope.Control.Loading = false;
                		$scope.$parent.GenericFailure = false;
                		$scope.Control.Loading = false;


                		if (shippingMethod.MethodId != $scope.Order.Current.ShippingMethod.MethodId || shippingMethod.CompanyId != $scope.Order.Current.ShippingMethod.CompanyId || paymentMethod.MethodId != $scope.Order.Current.PaymentMethod.MethodId || !addressCompare(shippingAddress, $scope.Order.Current.Shipping) || (!$scope.BillingAsShipping && !addressCompare(billingAddress, $scope.Order.Current.Billing)) || !checkProducts(products, $scope.Order.Current.Products)) {

                			$scope.$parent.IsFailed = true;
                			$scope.$parent.IsChanged = true;
                			$scope.$parent.Locked = false;

                			var elem = $('*[data-message="orderChanged"]');
                			if (elem.length > 0) {
                				$scope.$parent.scrollTo({
                					el: elem.get(0),
                					offset: -40,
                					timeout: 200
                				});
                			}

                			$scope.$parent.StepNumber = 1;
                			$scope.$parent.scrollTo({
                				el: $('.checkout-steps', $element).get(0),
                				offset: $('.checkout-steps', $element).data('offset') || 0,
                				timeout: 200
                			});

                			$('.x-checkoutshippingaddress').get(0).set(true);
                			$('.x-checkoutbillingaddress').get(0).set(true);
                			$('.x-checkoutpaymentmethod').get(0).reload();
                			$('.x-checkoutshippingmethod').get(0).reload();

                            $scope.$parent.Locked = false;

                            if ($(".checkout-loading").length > 0)
                                $(".checkout-loading").hide();

                		} else {
                			$scope.$parent.IsChanged = false;
                            ControlService.invokeCheckout($scope, $element, 'SubmitOrder', [profile, deliveryPoint, store, shippingAddress, comments, billingAddress, shippingMethod, paymentMethod, coupon, giftWrap, orderType, password, testCode, orderTimeslot, sellerCode, orderExplicitTimeslot, pickupPoint]).then(function (response) {

                				var result = jQuery.parseJSON(response);
                				deferred.resolve(result);
                				$scope.Control.Loading = false;
                			}, function (ex) {
                				deferred.reject(ex);
                				$scope.Control.Loading = false;
                			});
                		}

                	}, function (error) {
                		$scope.$parent.GenericFailure = true;
                		$scope.$parent.IsFailed = true;
                		var elem = $('*[data-message="genericFailure"]');
                		if (elem.length > 0) {
                			$scope.$parent.scrollTo({
                				el: elem.get(0),
                				offset: -40,
                				timeout: 200
                			});
                		}
                		$scope.Control.Loading = false;
                		throw error;
                	});

                } else {
                    ControlService.invokeCheckout($scope, $element, 'SubmitOrder', [profile, deliveryPoint, store, shippingAddress, comments, billingAddress, shippingMethod, paymentMethod, coupon, giftWrap, orderType, password, testCode, orderTimeslot, sellerCode, orderExplicitTimeslot, pickupPoint]).then(function (response) {

                		var result = jQuery.parseJSON(response);
                		deferred.resolve(result);
                		$scope.Control.Loading = false;
                	}, function (ex) {
                		deferred.reject(ex);
                		$scope.Control.Loading = false;
                	});

                }
                return deferred.promise;
            };

            if ($scope.Config.IsLazyloadAvailabilitiesEnabled) {
                var postalCodePrev;
                $scope.$watch('Order.Current.Products', function (newValue, prevValue) {
                    if (!prevValue || !newValue)
                        return;

                    var newArrayIds = [];
                    var prevArrayIds = [];
                    newValue.forEach(function (orderItem) { newArrayIds.push(orderItem.Id + '-' + orderItem.Quantity); });
                    prevValue.forEach(function (orderItem) { prevArrayIds.push(orderItem.Id + '-' + orderItem.Quantity); });

                    if (firstLoadForProducts) {
                        postalCodePrev = $scope.Order.Current.Shipping.PostCode;
                    }

                    var postalCode = $scope.Order.Current.Shipping.PostCode;
                    var store = $scope.Order.Current.Store.Id;

                    if (!firstLoadForProducts && postalCode.length == 5 && $scope.Order.Current.DeliveryPoint.Code.indexOf("onSite") > -1) {
                        if ((JSON.stringify(newArrayIds) !== JSON.stringify(prevArrayIds)) || (!deliveryAvailabilities || !orderDeliveryAvailability) || postalCodePrev !== postalCode) {
                            //call service and extend order model
                            $scope.bindDeliveryAvailabilities(postalCode);
                            postalCodePrev = $scope.Order.Current.Shipping.PostCode;
                        } else {
                            //extend model without calling the service again
                            _.each($scope.Order.Current.Products, function (item) {
                                var selectedProduct = _.find(deliveryAvailabilities, function (x) { return item.VariantId === x.Variant })
                                if (selectedProduct) item.Availability = selectedProduct.Message;
                            });

                            angular.extend($scope.Order.Current, orderDeliveryAvailability);                           
                        }                        
                    }

                    if (!firstLoadForProducts && store !== 0 && $scope.Order.Current.DeliveryPoint.Code.indexOf("fromStore") > -1) {
                        if ((JSON.stringify(newArrayIds) !== JSON.stringify(prevArrayIds)) || (!pickupAvailabilities || !orderPickupAvailability)) {
                            //call service and extend order model
                            $scope.bindPickupAvailabilities(store);
                        } else {
                            //extend model without calling the service again
                            _.each($scope.Order.Current.Products, function (item) {
                                var selectedProduct = _.find(pickupAvailabilities, function (x) { return item.VariantId === x.Variant })
                                if (selectedProduct) item.Availability = selectedProduct.Shops[0].Message;
                            });

                            angular.extend($scope.Order.Current, orderPickupAvailability);
                        }
                    }

                    firstLoadForProducts = false;
                    
                });

                $scope.$watch('Order.Current.Store.Id', function (newStore, prevStore) {
               
                    if (newStore !== 0 && $scope.Order.Current.DeliveryPoint.Code.indexOf("fromStore") > -1) {
                        if (firstLoadForStore || (!firstLoadForStore && newStore !== prevStore)) {
                            //call service and extend order model
                            $scope.bindPickupAvailabilities(newStore);
                        }
                    } else {
                        if (!firstLoadForStore) {
                            //reset model
                            $scope.resetPickupAvailabilities();
                        }
                    }

                    firstLoadForStore = false;

                });

                $scope.bindDeliveryAvailabilities = function (postalCode) {
                    //set an array with all products
                    var variantArray = [];
                    _.each($scope.Order.Current.Products, function (item) {
                        var variant = {
                            VariantId: item.VariantId,
                            Quantity: item.Quantity
                        };
                        variantArray.push(variant);
                    });

                    //call service for delivery availabilities
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        contentType: 'application/json; charset=UTF-8',
                        ContentType: 'application/json; charset=UTF-8',
                        url: LhApp.Function.Url.getServiceEndpoint('EcomService.svc/GetDeliveryAvailabilityData'),
                        async: false,
                        data: JSON.stringify({
                            lstVariantInfo: variantArray,
                            postalCode: postalCode,
                            isOrder: true,
                            shippingCompany: null
                        }),
                        error: function (response) { },
                        success: function (response) {
                            var data = jQuery.parseJSON(response.d.data);

                            if (data) {
                                //extend order model
                                deliveryAvailabilities = data.DeliveryAvailabilities;
                                _.each($scope.Order.Current.Products, function (item) {
                                    var selectedProduct = _.find(deliveryAvailabilities, function (x) { return item.VariantId === x.Variant })
                                    if (selectedProduct) item.Availability = selectedProduct.Message;
                                });

                                orderDeliveryAvailability = { HasOrderAvailability: true, OrderAvailabilityMessage: data.OrderAvailability.Message }   
                                angular.extend($scope.Order.Current, orderDeliveryAvailability);

                            } else {
                                //reset model
                                $scope.resetDeliveryAvailabilities();
                            }        

                        }
                    });
                };

                $scope.bindPickupAvailabilities = function (partnerId) {
                    //set an array with all products
                    var variantArray = [];
                    _.each($scope.Order.Current.Products, function (item) {
                        var variant = {
                            VariantId: item.VariantId,
                            Quantity: item.Quantity
                        };
                        variantArray.push(variant);
                    });

                    //call service for pick up availabilities
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        contentType: 'application/json; charset=UTF-8',
                        ContentType: 'application/json; charset=UTF-8',
                        url: LhApp.Function.Url.getServiceEndpoint('EcomService.svc/GetPickupAvailabilityData'),
                        async: false,
                        data: JSON.stringify({
                            lstVariantInfo: variantArray,
                            partnerId: partnerId,
                            isOrder: true
                        }),
                        error: function (response) { },
                        success: function (response) {
                            var data = jQuery.parseJSON(response.d.data);

                            if (data) {
                                //extend order model
                                pickupAvailabilities = data.PickupAvailabilities;
                                _.each($scope.Order.Current.Products, function (item) {
                                    var selectedProduct = _.find(pickupAvailabilities, function (x) { return item.VariantId === x.Variant })
                                    if (selectedProduct) item.Availability = selectedProduct.Shops[0].Message;
                                });

                                orderPickupAvailability = { HasOrderAvailability: true, OrderAvailabilityMessage: data.OrderAvailability.Message }
                                angular.extend($scope.Order.Current, orderPickupAvailability);

                            } else {
                                //reset model
                                $scope.resetPickupAvailabilities();
                            }

                        }
                    });
                };

                $scope.resetDeliveryAvailabilities = function () {
                    //reset model
                    deliveryAvailabilities = [];
                    _.each($scope.Order.Current.Products, function (item) { item.Availability = ''; });

                    orderDeliveryAvailability = { HasOrderAvailability: false, OrderAvailabilityMessage: '' }
                    angular.extend($scope.Order.Current, orderDeliveryAvailability);                     
                };

                $scope.resetPickupAvailabilities = function () {
                    //reset model
                    pickupAvailabilities = [];
                    _.each($scope.Order.Current.Products, function (item) { item.Availability = ''; });

                    orderPickupAvailability = { HasOrderAvailability: false, OrderAvailabilityMessage: '' }
                    angular.extend($scope.Order.Current, orderPickupAvailability);
                };

            }

            $scope.Control.extendB2BModel = function () {
                if (window.B2BModel === undefined) return;
                angular.extend($scope.Model.Data, window.B2BModel);
            };

            ControlService.getCheckoutData("GetOrderData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                //extend b2b model
                $scope.Control.extendB2BModel();
                //extend model
                if (checkoutOverrides && checkoutOverrides.Order && typeof checkoutOverrides.Order.ExtendModel === 'function'){
                    $.extend($scope.Model.Data,checkoutOverrides.Order.ExtendModel($scope.Model.Data));
                }

                $scope.Model.Data.CanCreateAccount = checkoutConfig.canCreateAccount;
                $scope.setControlValue(controlName, $scope.Model.Data);
                $scope[controlName].Texts = $scope.Model.Text;
                $scope.Control.Loading = false;

            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

        });
})();